import { useEffect, useRef, useState } from 'react'

import { getMockApplicantCompliance } from '../../../../../RentalPortalApplicant'

export function useApplicantProfileCompliance({ applicantId }) {
  const [reloadKey, setReloadKey] = useState(0)

  const [compliance, setCompliance] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoading, setLoading] = useState(true)

  const readIdRef = useRef(0)

  function handleReload() {
    readIdRef.current += 1

    const readId = readIdRef.current

    setLoading(true)

    return getMockApplicantCompliance({ applicantId })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setCompliance(data)
          setError(false)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setError(true)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoading(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (applicantId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- the in-flight flag flips when the read starts
      handleReload()
    }
  }, [applicantId, reloadKey])

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    handleRefresh,
    handleReload,
    handoff: compliance?.handoff,
    hasError,
    isInitiated,
    isLoading,
    screening: compliance?.screening,
  }
}
